/*
  Round descriptions:

  Round 125 = Quarter-Final / rounds.quarterFinal
  Round 150 = Semi-Final / rounds.semiFinal
  Round 160 = Playoff / rounds.playOff
  Round 170 = Playoff Semi-Final / rounds.semiFinal
  Round 180 = Playoff Final / rounds.playoffFinal
  Round 200 = Final / rounds.final
  Round 500 = Pre-Season / rounds.preSeason
*/

function getRound(round, leagueId) {
  switch (true) {
    case round === '125':
      return 'quarterFinal';

    case round === '150':
      return 'semiFinal';

    case round === '160':
      return 'playOff';

    case round === '170':
      return 'playOffSemiFinal';

    case round === '180':
      return 'playoffFinal';

    case round === '200':
      return 'final';

    case round === '500':
      return 'preSeason';

    case round === '16' && leagueId === '4480':
      return 'roundOf16';

    case !round:
      return round;
    default:
      return Number(round);
  }
}

export default getRound;
